export default __webpack_public_path__ + "static/media/resnetgru7.4cab73d5.png";